import styles from "./infrastructure.module.scss";
import checkmark from "../../../images/checkmark.svg";
import checkmarkchecked from "../../../images/checkmarkchecked.svg";
import { InfrastructureType } from "../../../hooks/useInfrastructure";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface InfrastructureProps {
  infrastructure: InfrastructureType;
}

const Infrastructure: FC<InfrastructureProps> = ({ infrastructure }) => {
  const { t } = useTranslation();
  return (
    <ul className={styles.listInfrastructure}>
      <li>
        <img
          src={infrastructure.electricity ? checkmarkchecked : checkmark}
          alt="Checkmark"
        />{" "}
        {t("infrastructure.electricity")}
      </li>
      <li>
        <img
          src={infrastructure.water ? checkmarkchecked : checkmark}
          alt="Checkmark"
        />{" "}
        {t("infrastructure.waterAndDrainage")}
      </li>
      <li>
        <img
          src={infrastructure.sewerage ? checkmarkchecked : checkmark}
          alt="Checkmark"
        />{" "}
        {t("infrastructure.sewerage")}
      </li>
      <li>
        <img
          src={infrastructure.gas ? checkmarkchecked : checkmark}
          alt="Checkmark"
        />{" "}
        {t("infrastructure.gasPipelines")}
      </li>
      <li>
        <img
          src={infrastructure.telecom ? checkmarkchecked : checkmark}
          alt="Checkmark"
        />{" "}
        {t("infrastructure.telecom")}
      </li>
    </ul>
  );
};

export default Infrastructure;
